export enum ReviewPrizepoolStep {
    Intro = 'intro',
    Form = 'form',
    ThankYou = 'thankYou',
}

export enum ReviewPlatform {
    Trustpilot = 'trustpilot',
    G2 = 'g2',
}

export const REVIEW_PLATFORMS = Object.values(ReviewPlatform);

/** Long enough for the `duration: 1` "Copied" toast to clear before the popup takes over. */
export const QUALIFYING_ACTION_DELAY = 1_800;
